var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9879 8C15.8289 8 15.6688 8.03441 15.5209 8.10427L3.18009 13.921C2.51164 14.2356 2.49347 15.1997 3.14967 15.5404L7.09022 17.5836V21.5147C7.09022 22.1416 7.58849 22.6505 8.20243 22.6505H23.7734C24.3874 22.6505 24.8857 22.1416 24.8857 21.5147V17.5836L27.1101 16.43V18.1072V20.3788V21.5147C27.108 21.6652 27.1352 21.8146 27.1902 21.9543C27.2452 22.0939 27.3267 22.2211 27.4302 22.3283C27.5337 22.4354 27.657 22.5206 27.793 22.5787C27.929 22.6368 28.0749 22.6667 28.2223 22.6667C28.3697 22.6667 28.5156 22.6368 28.6516 22.5787C28.7876 22.5206 28.9109 22.4354 29.0144 22.3283C29.1179 22.2211 29.1995 22.0939 29.2544 21.9543C29.3094 21.8146 29.3366 21.6652 29.3345 21.5147V20.3788V18.1072V14.6996H29.3041C29.2908 14.3843 29.1223 14.0747 28.7958 13.921L16.455 8.10427C16.3071 8.03441 16.147 8 15.9879 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/Student.a16e6b679ea9e33639ac396a4aebfad4.svg";
export { ForwardRef as ReactComponent };